import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Link } from 'react-router-dom';
import { IconDown } from '../../../styles/icons';
import * as colors from '../../../styles/colors';

const SideBarMenuItem = ({
  to,
  title,
  icon,
  dropdown,
}) => {
  const Icon = icon;
  return (
    <Wrapper>
      <LinkButton to={to}>
        <Left>
          <LinkIcon><Icon /></LinkIcon>
          <LinkText>{title}</LinkText>
        </Left>
        {
          dropdown
            ? <IconDown /> : ''
        }
      </LinkButton>
    </Wrapper>
  );
};

SideBarMenuItem.propTypes = {
  title: PropTypes.string.isRequired,
  to: PropTypes.string.isRequired,
  icon: PropTypes.func.isRequired,
  dropdown: PropTypes.bool,
};

SideBarMenuItem.defaultProps = {
  dropdown: false,
};

const Wrapper = styled.li`
  display: flex;
`;
const LinkButton = styled(Link)`
  height: 44px;
  padding: 9px 25px;
  cursor: pointer;
  text-decoration: none !important;
  display: flex;
  padding: 9px 25px;
  flex-grow: 1;
  align-items: center;
  transition: .4s all;
  justify-content: space-between;
  :hover {
    background-color: #1a1a27;
    span:first-child {
      color: #9ea9f0;
    }
  }
  i {
    color: ${colors.sideBarIcon};
  }
`;
const LinkIcon = styled.span`
  color: ${colors.sideBarIcon};
  font-size: 1.3rem;
  padding-right: 10px;
  display: flex; 
  align-items: center;
  transition: .4s all;
  i {
    display: flex !important;
    align-items: center;
  }
`;
const LinkText = styled.span`
  color: ${colors.sideBarText};
  font-size: 0.9rem;
  font-weight: 300;
  display: flex; 
  align-items: center;
`;
const Left = styled.div`
  display: flex;
`;

export default SideBarMenuItem;
